import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import store from "../../../../_services/store";
import { htmlToObject } from "../../../../_services/utils/utils";
import { COLORS } from "../../../../constants";
import { DropContainer, ValidateButton } from "../components";
import Modal from "../modal";

const modalDefaultProps = {
  isOpen: false,
  title: "",
  content: "",
  btn1: {
    label: "",
    func: () => { }
  }
}

const QuizzFillblank = () => {
  const navigate = useNavigate();
  const [choice, setChoice] = useState({});
  const [modal, setModal] = useState<TQuizzModalProps>(modalDefaultProps);

  if (store.quizzes === null || store.currentQuestion === null) {
    return <p>No Quizzes or no questions, should not happen</p>;
  }

  const currentQuestion = store.currentQuestion.data;
  if (!currentQuestion) return <></>;

  const passageElement = htmlToObject(currentQuestion.question_response.content!)

  const { quizzId } = store;

  const saveFilledChoice = (event: ChangeEvent<HTMLSelectElement>, i: { id: string | number; }) => {
    const respObj = {
      id: i.id,
      val: event.target.value,
    };
    const newChoice = { ...choice };
    newChoice[i.id] = respObj

    setChoice(newChoice)
  };

  const validateFillBlankResponses = () => {
    //get question solutions from store
    const solutions = store.currentQuestion?.data.question_response.response;

    //if not enough response, the quiz is failed
    if (!isCompleted) return false;

    let _choice = { ...choice };
    console.log(
      "🚀 ~ file: selectanswer.js ~ line 507 ~ validateFillBlankResponses ~ _choice",
      _choice
    );

    let succeed = true;
    //If at least one answer is wrong, quizz is failed
    Object.keys(_choice).map((selectInputIndex) => {
      let solution = solutions?.find(
        //@ts-ignore
        (s) => s.select === parseInt(selectInputIndex)
      );
      //@ts-ignore
      if (_choice[selectInputIndex].val === solution?.answer) {
        _choice[selectInputIndex].validated = 1;
        console.log("GOOD RESULT IS", _choice[selectInputIndex])
      } else {
        _choice[selectInputIndex].validated = 0;
        succeed = false;
      }
    });
    setChoice(_choice);

    return succeed;
  };

  const validateChoice = () => {
    const resultIsGood = validateFillBlankResponses();

    if (resultIsGood) {
      setModal({
        isOpen: true,
        title: "Bravo",
        content: "Vous n’avez fait aucune faute",
        btn1: {
          label: "Passer au suivant",
          func: () => { save() }
        }
      });
    }
    else {
      setModal({
        isOpen: true,
        title: "Deuxième chance",
        content: "Vous avez fait des erreurs, souhaitez-vous valider ou réessayer ?",
        btn1: {
          label: "Valider",
          func: () => { save() }
        },
        btn2: {
          label: "Réessayer",
          func: () => { retry() }
        }
      });
    }
  }

  function save() {
    const { question_id } = currentQuestion.question_response;
    const resultIsGood = validateFillBlankResponses();

    store.setQuizzResp({
      id: quizzId,
      //@ts-ignore
      val: {
        [question_id]: {
          val: choice,
          validated: resultIsGood ? 1 : 0,
        },
      },
    });
    store.sendQuizzResults();
    setModal({ ...modal, ...{ isOpen: false } });
    goNext()
  }
  function retry() {
    setChoice({})
    setModal({ ...modal, ...{ isOpen: false } });
  }

  const goNext = () => {
    console.log("🚀 ~ file: quizz.js ~ line 99 ~ gotoNext ~ index", store.questionIndex);
    setChoice({})
    const nextIndex = store.questionIndex + 1;
    //if there is a next another question
    if (store.resQuiz[nextIndex]) {
      store.setCurrentQuestion({
        id: nextIndex,
        data: store.resQuiz[nextIndex],
      });
      store.setQuestionIndex(nextIndex);
      console.log(
        " -- gotoNext question index: ",
        store.questionIndex,
        nextIndex,
        store.currentQuestion
      );
    } else {
      console.log(" -- gotoNext question index: no more question");
      store.sendQuizzResults();
      navigate(-1);
      
    }
  };

  function decodeHtml(html: string) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  const isCompleted = Object.keys(choice).length === passageElement.length;
  console.log("QUESTION ID",currentQuestion.question_response.question_id);
  

  return (
    <DropContainer style={{ gap: 0, maxWidth: 'none', margin: 32, alignItems: 'start' }}>
      {passageElement.map((row, k) => {
        return (
          <>
            <p style={{ textAlign: 'start' }}>{decodeHtml(row.text)}</p>
            <div
              style={{
                backgroundColor: COLORS.WHITE,
                borderRadius: 5,
              }}
              key={`sel${k}`}
            >
              <select className="select2"
                onChange={(e) => {
                  saveFilledChoice(e, row.select);
                }}
                defaultValue={row.select.options?.[0].value}
                value={choice[row.select.id]?.val || row.select.options?.[0].value}
                aria-placeholder={"-"}
              >
                {row.select.options.map(e =>
                  <option value={e.value}>{e.label}</option>
                )}
              </select>
            </div>
          </>
        );
      })}

      {
        isCompleted &&
        <ValidateButton
          onClick={() => { validateChoice() }}
          style={{ margin: '16px auto' }}
          key="validateButton"
        >
          Valider vos choix
        </ValidateButton>
      }
      <Modal
        isOpen={modal.isOpen}
        title={modal.title}
        content={modal.content}
        btn1={modal.btn1}
        btn2={modal.btn2}
      />
    </DropContainer>
  )
}

export default QuizzFillblank;